import { Breadcrumb, Container } from '@grupoboticario/flora-react';
import { useParams } from 'react-router';
import { Layout } from 'ui/components';

import { categoriesIcons } from './Departments/components/Categories/__data__/categoriesIcons';

export const PageCategoryBreadCrumb = () => {
  const { department } = useParams();

  const textCategory = categoriesIcons.find(
    (element) => element.slugName === department || element.tagName === department,
  );

  return (
    <Layout
      full-page={false}
      horizontal-align="left"
      loading={false}
      vertical-align="top"
      data-testid="page-showcase"
    >
      <Layout full-page={false} horizontal-align="center" vertical-align="center">
        <Container size="large" css={{ margin: '$4 0', display: 'flex' }}>
          <Breadcrumb
            navigation={[
              {
                text: 'Início',
                url: '/departamentos',
              },
              {
                text: textCategory?.name || 'Categorias',
                url: '',
              },
            ]}
          />
        </Container>
      </Layout>
    </Layout>
  );
};
